import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/helpers/cn';
import { forwardRef } from 'react';
const squareSize = {
    large: 'w-4 h-4',
    medium: 'w-3 h-3',
    small: 'w-2 h-2',
};
export const Spinner = forwardRef(({ size = 'medium', className, 'aria-label': ariaLabel, ...props }, ref) => {
    return (_jsx("span", { className: cn('animate-loader relative flex border-[1.5px] border-grey-20', squareSize[size], className), "aria-label": ariaLabel, ref: ref, ...props, children: _jsx("span", { className: "animate-loader-inner inline-block w-full bg-surface-brand align-top" }) }));
});
Spinner.displayName = 'Spinner';
export default Spinner;
